module.exports = __webpack_public_path__ + "970370d252e98d674d5daf23c2f49930.png";